/** Copyright © 2013-2021 DataYes, All Rights Reserved. */

import React from 'react';
import { StyledNav } from './style';

const getClass = (key: any, activeKey: any) =>
  (Array.isArray(key) ? key.some((k) => k === activeKey) : key === activeKey) ? 'active' : '';

const Nav = ({ navs = [], activeKey, isSub }: any) => {
  const navsEle = navs.map(
    ({ key, url, hide, text }: any, index: number) =>
      !hide && (
        // eslint-disable-next-line react/no-array-index-key
        <li key={index} className={getClass(key, activeKey)}>
          <a href={url} target="_blank">
            {text}
          </a>
        </li>
      )
  );
  return isSub ? <ul>{navsEle}</ul> : <StyledNav>{navsEle}</StyledNav>;
};

export default Nav;
